import { render, staticRenderFns } from "./RuleDetail.vue?vue&type=template&id=70478370&scoped=true"
import script from "./RuleDetail.vue?vue&type=script&lang=js"
export * from "./RuleDetail.vue?vue&type=script&lang=js"
import style0 from "./RuleDetail.vue?vue&type=style&index=0&id=70478370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70478370",
  null
  
)

export default component.exports